// 统计
import * as activity from 'activityConfigES';
import $ from 'jquery';
import * as api from './api.js';
// import * as utils from './utils.js';
import { getParam } from 'utilsES';
import language from './language';

export const init = function () {
  activity.stat();
  // ipToLang();
};
export const getBrowserLanguage = function () {
  if (window.navigator) {
    let lang =
      window.navigator.language ||
      window.navigator.browserLanguage ||
      window.navigator.systemLanguage;
    if (lang.indexOf('-') > -1) {
      let langArr = lang.split('-');
      let realLang = langArr[0].toLowerCase()+langArr[1].toLowerCase()
      return realLang;
    } else {
      let realLang = lang.toLowerCase();
      return realLang;
    }
  }
};
export const ipToLang = () => {
  api
    .ipArea()
    .then(({ data }) => {
      // const area = data.codeInfo[0];
      // const area = data.area;
      
      
      let area = getBrowserLanguage();
      let iparea = "";
      if (area.includes("vi")) {
        iparea = "vi";
      } else if (area.includes("th")) {
        iparea = "thai";
      } else {
        iparea = "zh";
      }
      // console.log(iparea);
      // const iparea = "vi";
      //设置语言
      // function setLangs() {
      //   switch (area) {
      //     case "vi": {
      //       return "vi"
      //       break
      //     }
      //     case "th": {
      //       return "thai"
      //       break
      //     }
      //     default:
      //       return "zh"
      //   }
      // }
      language.setLang(getParam('lang') || iparea);
      
      if (!getParam('lang')) {
        
        //切换域名
        let param = location.search;
        switch (iparea) {
          case "vi": {
            if (param) {
              param = param.substring(1);
              param = "&" + param;
            }
            // let a = top.window.location.href;
            if (!window.location.href.includes("endomainname")) {
              top.window.location.href = `https://dauladailuc3d.vn/dang-ky?eventname=dlssrvtyy${param}`;
            }
           
            break
          }
          default:
            // let b = top.window.location.href;
            // if (getParam('eventname')) {
            //   top.window.location.href = `https://gevents.37games.com/dlssrvtyy/index.html${param}`;
            // }
            if (!window.location.href.includes("37games")) {
              top.window.location.href = `https://gevents.37games.com/dlssrvtyy/index.html${param}`;
              // window.open("https://gevents.37games.com/dlssrvtyy/index.html");

            }
            break
            
        }
          
      }
        // language.setLang(getParam('lang') || iparea);
        
      // if (!getParam('lang') && localStorage.getItem('lang') != iparea) {
        
      //   localStorage.setItem('lang', iparea);
      //   //切换域名
      //   let param = location.search;
      //   switch (iparea) {
      //     case "vi": {
      //       if (param) {
      //         param = param.substring(1);
      //         param = "&" + param;
      //       }
      //       window.location.href = `https://dauladailuc3d.vn/dang-ky?eventname=dlssrvtyy${param}`;
      //       break
      //     }
      //     default:
      //       window.location.href = `https://gevents.37games.com/dlssrvtyy/index.html${param}`;
      //   }
          
      // }
      //language.setLang(localStorage.getItem('lang'));
    })
    .catch(err => {
      // utils.setLang("zh");
      language.setLang('zh');
      // window.location.href = `https://gevents.37games.com/dlssrvtyy/index.html`;
      //错误跳默认其他地区或者也可以不处理
    });
};